var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowFav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 17.2595L5.31278 19.8315C4.30268 20.3862 3.12268 19.4909 3.31518 18.3166L4.21028 12.867L0.41759 9.00704C-0.400109 8.17579 0.0511905 6.72729 1.17999 6.55505L6.42158 5.76034L8.76547 0.801551C9.27047 -0.267183 10.7294 -0.267183 11.2344 0.801551L13.5783 5.76034L18.82 6.55505C19.9488 6.72604 20.4001 8.17444 19.5826 9.00704L15.7898 12.867L16.6849 18.3166C16.8774 19.491 15.6973 20.3862 14.6873 19.8315L10.0006 17.2595Z",
    fill: "url(#paint0_linear_3154_46908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3154_46908",
    x1: 9.99997,
    y1: -0.00046975,
    x2: 9.99997,
    y2: 20.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFav);
export default __webpack_public_path__ + "static/media/yellow-fav.3523a2c7462ce29a24972376126dde02.svg";
export { ForwardRef as ReactComponent };